<script setup lang="ts">
import ScPage from '@/components/common/page/ScPage.vue';
import { onMounted, ref } from 'vue';
import { request } from '@/util/request';
import dayjs from 'dayjs';

const data = ref();
onMounted(async () => {
  data.value = await request('/management/app_installer/info');
});
</script>

<template>
  <sc-page title="应用下载下载">
    <template v-if="data">
      <div style="padding: 20px">
        <div style="margin-bottom: 20px">当前版本：{{ data.version }}</div>
        <div style="margin-bottom: 20px">
          发布时间： {{ dayjs(Number(data.createTime)).format('YYYY-MM-DD') }}
        </div>
        <div style="display: flex; flex-direction: row;margin-bottom: 30px">
          <div
            style="
              border-radius: 8px;
              border: 1px solid;
              width: 200px;
              height: 200px;
              display: flex;
              flex-direction: column;
              align-items: center;
            "
          >
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 10px;
              "
            >
              <sc-icon
                type="AndroidFilled"
                style="color: #2ecc7d; font-size: 24px; margin-right: 8px"
              />
              <div style="font-weight: bold">Android版</div>
            </div>
            <img :src="data.androidQr" style="width: 120px; height: 120px" />
            <div style="text-align: center">
              <a :href="data.android" target="_blank">
                <sc-btn type="link" text="点击下载" />
              </a>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 10px;">更新内容：</div>
        <div :style="{color: !data.desc ? '#AAA' : undefined}">
          {{ data.desc || '暂无说明' }}
        </div>
      </div>
    </template>
  </sc-page>
</template>

<style scoped lang="scss"></style>
